package ca.derekellis.reroute.map

import ca.derekellis.reroute.ui.Screen

object Map : Screen
